import React, { useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Tooltip, IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SettingsIcon from "@material-ui/icons/Settings";
import { withStyles } from "@material-ui/core/styles";
import ContractTypeForm from "./contractTypeForm";
import ContractModelsList from "./contractModelList";
import DialogCreateFormat from "./dialogCreateFormat";
import { getTipoDeContrato } from "../../../actions/dummy-actions";
import Visibility from "@material-ui/icons/Visibility";
import { Link, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "40.6%",
  },
  columnEvent: {
    paddingLeft: "10px",
    flexBasis: "50px",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
const ContractTypeAccordion = ({
  headers,
  data,
  onEdit,
  permissionsRequisition,
  permissionsConstans,
  history,
}) => {
  const classes = useStyles();
  const id = IdKey.generate();
  const [showForm, setShowForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const contractTypes = getTipoDeContrato();
  const { path } = useRouteMatch();
  const [showContractModelsForm, setShowContractModelsForm] = useState(false);
  const [openModalFormat, setOpenModalFormat] = useState(false);
  const [refreshFormat, setRefreshFormat] = useState(false);

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        if (header.field === "contractType") {
          let clave = object[header.field]?.toUpperCase();
          let valor = contractTypes.find((cont) => cont.key === clave);
          return valor ? valor.name : "";
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };
  const toggleForm = () => {
    setShowForm(!showForm);
    setShowDetails(true);
    setShowContractModelsForm(false);
  };

  const toggleContractModelsForm = () => {
    setShowContractModelsForm(!showContractModelsForm);
    setShowDetails(true);
    setShowForm(false);
  };

  const setOpenModalCreateFormat = () => {
    setOpenModalFormat(true);
    setShowContractModelsForm(false);
    setShowDetails(false);
    setShowForm(false);
  };

  const onClose = () => {
    setOpenModalFormat(false);
  };

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "FOR_TIP_CON");
    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.FOR_TIP_CON_EDITAR
      )
    ) {
      return (
        <div className={classes.columnEvent} onClick={toggleForm}>
          <Tooltip title="Editar" arrow placement="top">
            <IconButton>
              <EditIcon
                style={{ fontSize: 40, pointerEvents: "auto" }}
                className={classes.iconEvent}
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    }
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
        expanded={showDetails}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          style={{ pointerEvents: "none" }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          <Grid item xs={2}>
            <Typography
              className={classes.secondaryHeading}
              style={{ paddingTop: "10px" }}
            >
              <Link
                href="#"
                underline="always"
                onClick={() => setOpenModalCreateFormat()}
                style={{
                  color: "#4D8D9D",
                  fontWeight: "500",
                  cursor: "pointer",
                  pointerEvents: "auto",
                }}
              >
                Generar formato
              </Link>
            </Typography>
          </Grid>
          {validationPermission()}
          {/* <div
            className={classes.columnEvent}
            onClick={handleGoToConfiguration}
          >
            <Tooltip title="Configurar" arrow placement="top">
              <IconButton>
                <SettingsIcon
                  style={{ fontSize: 40, pointerEvents: "auto" }}
                  className={classes.iconEvent}
                />
              </IconButton>
            </Tooltip>
          </div> */}
          <div
            className={classes.columnEvent}
            onClick={toggleContractModelsForm}
          >
            <Tooltip title="Modelos" arrow placement="top">
              <IconButton>
                <VisibilityIcon
                  style={{
                    fontSize: 40,
                    pointerEvents: "auto",
                    marginRight: "10px",
                  }}
                  className={classes.iconEvent}
                />
              </IconButton>
            </Tooltip>
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          {showForm && (
            <div className={classes.rootGrid}>
              <ContractTypeForm
                id={data.id}
                data={data}
                toggleForm={toggleForm}
              />
            </div>
          )}
          {showContractModelsForm && (
            <div className={classes.rootGrid}>
              <ContractModelsList
                id={data.id}
                data={data}
                toggleContractModelsForm={toggleContractModelsForm}
              />
            </div>
          )}
        </AccordionDetails>
      </Accordion>

      {openModalFormat && (
        <DialogCreateFormat
          handleClose={onClose}
          open={openModalFormat}
          setOpen={setOpenModalFormat}
          contractTypeId={data.id}
          setRefreshFormat={setRefreshFormat}
          refreshFormat={refreshFormat}
          typeContractName={data.contractTypeDescription}
        />
      )}
    </div>
  );
};

export default withRouter(ContractTypeAccordion);
